module.exports = "/packs/banner_pc_marketer-aa9dfcc5e2676b16fb8c1a4fadb71d89.png";